var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFlagOpen = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 17,
  height: 19,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.313,
  d: "M16.227 7.55c-2.75 3.763-9.123.499-11.873 4.263-.837-2.078-1.405-3.714-2.241-5.791 2.75-3.764 8.86-.94 11.61-4.705q1.257 3.117 2.504 6.232M1.365 4.574l5.23 13.03"
})));
export default SvgFlagOpen;